{
  "enum": {
    "ExfOfacEmulatorV1OfacAkaCategory": {
      "STRONG": "Strong",
      "UNSPECIFIED": "Unspecified",
      "WEAK": "Weak"
    },
    "ExfOfacEmulatorV1OfacAkaType": {
      "AKA": "AKA",
      "FKA": "FKA",
      "UNSPECIFIED": "Unspecified"
    },
    "ExfOfacEmulatorV1OfacEmulatorStatus": {
      "CREATED": "Created",
      "DONE": "Done",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "ExfOfacEmulatorV1OfacIdType": {
      "EMULATOR": "Emulator",
      "NATIONAL_ID_NO": "National ID Number",
      "PASSPORT": "Passport",
      "UNSPECIFIED": "Unspecified"
    },
    "ExfOfacEmulatorV1OfacProgram": {
      "BALKANS": "Balkans",
      "CUBA": "Cuba",
      "EMULATOR": "Emulator",
      "IRAQ2": "Iraq2",
      "SDGT": "SDGT",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListFilterableFields": {
      "ofacEmulatorId": "OFAC Emulator",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExfOfacEmulatorV1OfacEmulatorEventType": {
      "created": "Created",
      "errored": "Errored",
      "process": "Process",
      "uploaded": "Uploaded"
    },
    "ExfOfacEmulatorV1SdnType": {
      "individual": "Individual",
      "organization": "Organization"
    }
  },
  "sortEnum": {
    "ExfOfacEmulatorV1OfacEmulatorQueryServiceOfacEmulatorListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}